/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UserRoleResource
 */
export interface UserRoleResource {
    /**
     * 
     * @type {string}
     * @memberof UserRoleResource
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof UserRoleResource
     */
    'resourceScope': UserRoleResourceResourceScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof UserRoleResource
     */
    'resourceId': string;
    /**
     * 
     * @type {string}
     * @memberof UserRoleResource
     */
    'role': UserRoleResourceRoleEnum;
}

export const UserRoleResourceResourceScopeEnum = {
    account: 'USER_ACCOUNT',
    accountGroup: 'USER_ACCOUNT_GROUP',
    accountAll: 'USER_ACCOUNT_ALL'
} as const;

export type UserRoleResourceResourceScopeEnum = typeof UserRoleResourceResourceScopeEnum[keyof typeof UserRoleResourceResourceScopeEnum];
export const UserRoleResourceRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type UserRoleResourceRoleEnum = typeof UserRoleResourceRoleEnum[keyof typeof UserRoleResourceRoleEnum];


